// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  message: 'DEV'
};

export const SERVER_URL = 'http://38.109.89.31:8087/XMSExpenseServiceUHILTEST/xmsrest/ExpenseReportRestService/';
// export const SERVER_URL = 'http://172.98.195.46:8087/XMSExpenseServiceDEV/xmsrest/ExpenseReportRestService/';
export const DOWNLOAD_URL = 'https://www.xmsapproveit.com/ApproveItMobileDev/';
export const VERSION_CNTRL = '1.1';

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
